// import React, { useState } from "react";
// import { ref, set } from "firebase/database";
// import { db } from "../../firebase";
// import { TbBottleFilled } from "react-icons/tb";
// import { GiWaterGallon } from "react-icons/gi";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import CloseIcon from "@mui/icons-material/Close";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";

// const services = [
//   {
//     title: "Shaadi (Wedding)",
//     img: "https://img.icons8.com/external-wanicon-flat-wanicon/64/DE3163/external-wedding-wedding-wanicon-flat-wanicon.png",
//   },
//   {
//     title: "Birthday Party",
//     img: "https://img.icons8.com/color/96/birthday.png",
//   },
//   {
//     title: "Restaurant / Hotel",
//     img: "https://img.icons8.com/color/96/restaurant.png",
//   },
//   { title: "Home", img: "https://img.icons8.com/color/96/home.png" },
//   {
//     title: "School / College",
//     img: "https://img.icons8.com/color/96/school.png",
//   },
//   { title: "Office", img: "https://img.icons8.com/color/96/company.png" },
//   { title: "Shop", img: "https://img.icons8.com/color/96/shop.png" },
//   {
//     title: "Other Event",
//     img: "https://img.icons8.com/color/96/event-accepted-tentatively.png",
//   },
// ];

// const Bookservices = () => {
//   const [selectedService, setSelectedService] = useState("");
//   const [form, setForm] = useState({
//     name: "",
//     contact: "",
//     date: "",
//     time: "",
//     jars: "",
//     capsules: "",
//     address: "",
//   });
//   const [popup, setPopup] = useState(false);

//   const handleSubmit = async () => {
//     if (!form.name || !form.contact || !form.date || !selectedService) {
//       alert("⚠️ Please fill all required fields before booking!");
//       return;
//     }

//     try {
//       const userKey = form.name.replace(/\s+/g, "");
//       const bookingRef = ref(db, `bookings/${userKey}`);

//       await set(bookingRef, {
//         name: form.name,
//         service: selectedService,
//         contact: form.contact,
//         date: form.date,
//         time: form.time || "Not specified",
//         jars: form.jars || "0",
//         capsules: form.capsules || "0",
//         address: form.address,
//         createdAt: new Date().toISOString(),
//       });

//       setPopup(true);
//       setTimeout(() => {
//         setPopup(false);
//         setSelectedService("");
//       }, 2500);

//       setForm({
//         name: "",
//         contact: "",
//         date: "",
//         time: "",
//         jars: "",
//         capsules: "",
//         address: "",
//       });
//     } catch (error) {
//       console.error("Firebase Error:", error);
//       alert("❌ Failed to save booking. Try again later.");
//     }
//   };

//   return (
//     <>
//       <style>{`
//         .page {
//           padding: 20px;
//           min-height: 100vh;
//           background: #e0f7f7;
//           box-sizing: border-box;
//         }
//         @media (max-width: 600px) {
//           .page { padding-bottom: 80px; }
//         }

//         .title {
//           text-align: center;
//           margin-bottom: 25px;
//           font-size: 32px;
//           font-weight: 800;
//           color: #0a3258;
//           text-shadow: 0px 1px 2px rgba(0,0,0,0.2);
//         }

//         .grid {
//           display: grid;
//           grid-template-columns: repeat(4, 1fr);
//           gap: 25px;
//           padding: 10px;
//         }
//         @media (max-width: 900px) { .grid { grid-template-columns: repeat(2, 1fr);} }
//         @media (max-width: 500px) { .grid { grid-template-columns: repeat(1, 1fr);} }

//         .card {
//           text-align: center;
//           padding: 25px;
//           border-radius: 18px;
//           backdrop-filter: blur(10px);
//           border: 1px solid rgba(255,255,255,0.5);
//           background: rgba(255,255,255,0.6);
//           cursor: pointer;
//           transition: 0.35s ease;
//           box-shadow: 0 8px 16px rgba(0,0,0,0.1);
//         }
//         .card:hover {
//           transform: translateY(-8px) scale(1.03);
//           box-shadow: 0 12px 22px rgba(0,0,0,0.2);
//           background: rgba(255,255,255,0.95);
//         }

//         .modal-bg {
//           position: fixed;
//           inset: 0;
//           background: rgba(0,0,0,0.55);
//           backdrop-filter: blur(6px);
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           z-index: 999;
//         }

//         .modal-box {
//           background: rgba(255,255,255,0.9);
//           backdrop-filter: blur(15px);
//           padding: 18px;
//           border-radius: 16px;
//           width: 90%;
//           max-width: 420px;
//           box-shadow: 0 8px 20px rgba(0,0,0,0.25);
//           animation: pop .25s ease;
//         }

//         .modal-title {
//           text-align: center;
//           font-size: 22px;
//           font-weight: 800;
//           color: #038f8a;
//           margin-bottom: 10px;
//         }

//         .form-group { margin-bottom: 12px; }
//         .input-wrapper { position: relative; display: flex; align-items: center; }
//         .icon { position: absolute; left: 12px; font-size: 18px; opacity: 0.7; }

//         .input-wrapper input,
//         .input-wrapper textarea {
//           width: 100%;
//           padding: 10px 12px 10px 36px;
//           border-radius: 10px;
//           border: 1px solid #c7dce8;
//           background: #f9ffff;
//           font-size: 15px;
//         }

//         .btn {
//           width: 100%;
//           padding: 10px;
//           margin-top: 8px;
//           border: none;
//           background: linear-gradient(120deg, #03b8b3, #04d4cd);
//           color: white;
//           font-size: 15px;
//           font-weight: 700;
//           border-radius: 10px;
//           cursor: pointer;
//           transition: 0.3s;
//         }
//         .btn-close {
//           background: linear-gradient(120deg, #ff4d6d, #ff6b81);
//         }

//         .popup {
//           position: fixed;
//           top: 50%;
//           left: 50%;
//           transform: translate(-50%, -50%) scale(1);
//           background: white;
//           border-radius: 18px;
//           padding: 25px 30px;
//           text-align: center;
//           box-shadow: 0 8px 20px rgba(0,0,0,0.3);
//           z-index: 1200;
//           animation: fadeInOut 2.5s ease;
//         }

//         .popup h3 {
//           color: #03b8b3;
//           margin-top: 10px;
//           font-weight: 700;
//           font-size: 18px;
//         }

//         @keyframes fadeInOut {
//           0% { opacity: 0; transform: translate(-50%, -50%) scale(0.8); }
//           15% { opacity: 1; transform: translate(-50%, -50%) scale(1); }
//           85% { opacity: 1; }
//           100% { opacity: 0; transform: translate(-50%, -50%) scale(0.9); }
//         }
//       `}</style>

//       <div className="page">
//         <h2 className="title">Book Water Services</h2>

//         <div className="grid">
//           {services.map((ser, idx) => (
//             <div
//               key={idx}
//               className="card"
//               onClick={() => setSelectedService(ser.title)}
//             >
//               <img
//                 src={ser.img}
//                 style={{ width: 60, marginBottom: 10 }}
//                 alt="icon"
//               />
//               <h3>{ser.title}</h3>
//             </div>
//           ))}
//         </div>
//       </div>

//       {popup && (
//         <div className="popup">
//           <CheckCircleIcon style={{ color: "#03b8b3", fontSize: "45px" }} />
//           <h3>✅ Booking Confirmed Successfully!</h3>
//         </div>
//       )}

//       {selectedService && (
//         <div className="modal-bg">
//           <div className="modal-box">
//             <h2 className="modal-title">{selectedService} Booking</h2>

//             {/* ✅ Name and Contact */}
//             {[
//               {
//                 label: "Full Name",
//                 icon: "👤",
//                 key: "name",
//                 type: "text",
//                 placeholder: "Enter your name",
//               },
//               {
//                 label: "Contact Number",
//                 icon: "📞",
//                 key: "contact",
//                 type: "tel",
//                 placeholder: "Enter contact number",
//               },
//             ].map((f) => (
//               <div key={f.key} className="form-group">
//                 <label>{f.label}</label>
//                 <div className="input-wrapper">
//                   <i className="icon">{f.icon}</i>
//                   <input
//                     type={f.type}
//                     placeholder={f.placeholder}
//                     value={form[f.key]}
//                     onChange={(e) =>
//                       setForm({ ...form, [f.key]: e.target.value })
//                     }
//                   />
//                 </div>
//               </div>
//             ))}

//             {/* ✅ Date and Time side by side like Jars & Capsules */}
//             <div className="form-row" style={{ display: "flex", gap: "10px" }}>
//               {[
//                 { label: "Select Date", icon: "📅", key: "date", type: "date" },
//                 { label: "Select Time", icon: "⏰", key: "time", type: "time" },
//               ].map((f) => (
//                 <div
//                   key={f.key}
//                   className="form-group half"
//                   style={{ flex: 1 }}
//                 >
//                   <label>{f.label}</label>
//                   <div className="input-wrapper">
//                     <i className="icon">{f.icon}</i>
//                     <input
//                       type={f.type}
//                       value={form[f.key]}
//                       onChange={(e) =>
//                         setForm({ ...form, [f.key]: e.target.value })
//                       }
//                     />
//                   </div>
//                 </div>
//               ))}
//             </div>

//             {/* ✅ Jars & Capsules remain same */}
//             <div className="form-row" style={{ display: "flex", gap: "10px" }}>
//               <div className="form-group half">
//                 <label>Water Jars</label>
//                 <div className="input-wrapper">
//                   <TbBottleFilled color="#03b8b3" className="icon" />
//                   <input
//                     type="number"
//                     placeholder="Qty"
//                     value={form.jars}
//                     onChange={(e) => setForm({ ...form, jars: e.target.value })}
//                   />
//                 </div>
//               </div>

//               <div className="form-group half">
//                 <label>Capsules</label>
//                 <div className="input-wrapper">
//                   <GiWaterGallon color="#03b8b3" className="icon" />
//                   <input
//                     type="number"
//                     placeholder="Qty"
//                     value={form.capsules}
//                     onChange={(e) =>
//                       setForm({ ...form, capsules: e.target.value })
//                     }
//                   />
//                 </div>
//               </div>
//             </div>

//             <div className="form-group">
//               <label>Address</label>
//               <div className="input-wrapper">
//                 <LocationOnIcon style={{ color: "red" }} className="icon" />
//                 <textarea
//                   placeholder="Enter full address"
//                   value={form.address}
//                   onChange={(e) =>
//                     setForm({ ...form, address: e.target.value })
//                   }
//                 ></textarea>
//               </div>
//             </div>

//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "5px",
//                 justifyContent: "center",
//               }}
//             >
//               <button className="btn" onClick={handleSubmit}
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "5px",
//                 justifyContent: "center",
//               }}
//               >
//                 Book Now ✅
//               </button>
//               <button
//                 className="btn btn-close"
//                 onClick={() => setSelectedService("")}
//                 style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "5px",
//                 justifyContent: "center",
//               }}
//               >
//                 Cancel <CloseIcon />
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default Bookservices;

import React, { useState } from "react";
import { ref, set } from "firebase/database";
import { db } from "../../firebase";
import { TbBottleFilled } from "react-icons/tb";
import { GiWaterGallon } from "react-icons/gi";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const services = [
  {
    title: "Shaadi (Wedding)",
    img: "https://img.icons8.com/external-wanicon-flat-wanicon/64/DE3163/external-wedding-wedding-wanicon-flat-wanicon.png",
  },
  {
    title: "Birthday Party",
    img: "https://img.icons8.com/color/96/birthday.png",
  },
  {
    title: "Restaurant / Hotel",
    img: "https://img.icons8.com/color/96/restaurant.png",
  },
  { title: "Home", img: "https://img.icons8.com/color/96/home.png" },
  {
    title: "School / College",
    img: "https://img.icons8.com/color/96/school.png",
  },
  { title: "Office", img: "https://img.icons8.com/color/96/company.png" },
  { title: "Shop", img: "https://img.icons8.com/color/96/shop.png" },
  {
    title: "Other Event",
    img: "https://img.icons8.com/color/96/event-accepted-tentatively.png",
  },
];

const Bookservices = () => {
  const [selectedService, setSelectedService] = useState("");
  const [form, setForm] = useState({
    name: "",
    contact: "",
    date: "",
    time: "",
    jars: "",
    capsules: "",
    address: "",
  });
  const [popup, setPopup] = useState(false);

  const isFormValid =
    form.name.trim() &&
    /^(0)?[6-9]\d{9}$/.test(form.contact) &&
    form.address.trim() &&
    Number(form.jars) >= 0 &&
    Number(form.capsules) >= 0 &&
    (Number(form.jars) > 0 || Number(form.capsules) > 0);

  const handleSubmit = async () => {
    if (!isFormValid || !form.date || !selectedService) {
      alert("⚠️ Please fill all required fields correctly!");
      return;
    }

    try {
      const cleanName = form.name.replace(/\s+/g, " ").trim(); // display & save
      const userKey = cleanName.replace(/\s+/g, ""); // firebase path

      const bookingRef = ref(db, `bookings/${userKey}`);

      await set(bookingRef, {
        name: cleanName,
        service: selectedService,
        contact: form.contact,
        date: form.date,
        time: form.time || "Not specified",
        jars: Number(form.jars) || 0,
        capsules: Number(form.capsules) || 0,
        address: form.address,
        createdAt: new Date().toISOString(),
      });

      setPopup(true);
      setTimeout(() => {
        setPopup(false);
        setSelectedService("");
      }, 2500);

      setForm({
        name: "",
        contact: "",
        date: "",
        time: "",
        jars: "",
        capsules: "",
        address: "",
      });
    } catch (error) {
      console.error("Firebase Error:", error);
      alert("❌ Failed to save booking. Try again later.");
    }
  };

  return (
    <>
      <style>{`
        .page {
          padding: 20px;
          min-height: 100vh;
          background: #e0f7f7;
          box-sizing: border-box;
        }
        @media (max-width: 600px) {
          .page { padding-bottom: 80px; }
        }

        .title {
          text-align: center;
          margin-bottom: 25px;
          font-size: 32px;
          font-weight: 800;
          color: #0a3258;
          text-shadow: 0px 1px 2px rgba(0,0,0,0.2);
        }

        .grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 25px;
          padding: 10px;
        }
        @media (max-width: 900px) { .grid { grid-template-columns: repeat(2, 1fr);} }
        @media (max-width: 500px) { .grid { grid-template-columns: repeat(1, 1fr);} }

        .card {
          text-align: center;
          padding: 25px;
          border-radius: 18px;
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255,255,255,0.5);
          background: rgba(255,255,255,0.6);
          cursor: pointer;
          transition: 0.35s ease;
          box-shadow: 0 8px 16px rgba(0,0,0,0.1);
        }
        .card:hover {
          transform: translateY(-8px) scale(1.03);
          box-shadow: 0 12px 22px rgba(0,0,0,0.2);
          background: rgba(255,255,255,0.95);
        }

        .modal-bg {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.55);
          backdrop-filter: blur(6px);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 999;
        }

        .modal-box {
          background: rgba(255,255,255,0.9);
          backdrop-filter: blur(15px);
          padding: 18px;
          border-radius: 16px;
          width: 90%;
          max-width: 420px;
          box-shadow: 0 8px 20px rgba(0,0,0,0.25);
          animation: pop .25s ease;
        }

        .modal-title {
          text-align: center;
          font-size: 22px;
          font-weight: 800;
          color: #038f8a;
          margin-bottom: 10px;
        }

        .form-group { margin-bottom: 12px; }
        .input-wrapper { position: relative; display: flex; align-items: center; }
        .icon { position: absolute; left: 12px; font-size: 18px; opacity: 0.7; }

        .input-wrapper input,
        .input-wrapper textarea {
          width: 100%;
          padding: 10px 12px 10px 36px;
          border-radius: 10px;
          border: 1px solid #c7dce8;
          background: #f9ffff;
          font-size: 15px;
        }

        .btn {
          width: 100%;
          padding: 10px;
          margin-top: 8px;
          border: none;
          background: linear-gradient(120deg, #03b8b3, #04d4cd);
          color: white;
          font-size: 15px;
          font-weight: 700;
          border-radius: 10px;
          cursor: pointer;
          transition: 0.3s;
        }
        .btn-close {
          background: linear-gradient(120deg, #ff4d6d, #ff6b81);
        }

        .popup {
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) scale(1);
          background: white;
          border-radius: 18px;
          padding: 25px 30px;
          text-align: center;
          box-shadow: 0 8px 20px rgba(0,0,0,0.3);
          z-index: 1200;
          animation: fadeInOut 2.5s ease;
        }

        .popup h3 {
          color: #03b8b3;
          margin-top: 10px;
          font-weight: 700;
          font-size: 18px;
        }

        @keyframes fadeInOut {
          0% { opacity: 0; transform: translate(-50%, -50%) scale(0.8); }
          15% { opacity: 1; transform: translate(-50%, -50%) scale(1); }
          85% { opacity: 1; }
          100% { opacity: 0; transform: translate(-50%, -50%) scale(0.9); }
        }
      `}</style>

      <div className="page">
        <h2 className="title">Book Water Services</h2>

        <div className="grid">
          {services.map((ser, idx) => (
            <div
              key={idx}
              className="card"
              onClick={() => setSelectedService(ser.title)}
            >
              <img
                src={ser.img}
                style={{ width: 60, marginBottom: 10 }}
                alt="icon"
              />
              <h3>{ser.title}</h3>
            </div>
          ))}
        </div>
      </div>

      {popup && (
        <div className="popup">
          <CheckCircleIcon style={{ color: "#03b8b3", fontSize: "45px" }} />
          <h3>✅ Booking Confirmed Successfully!</h3>
        </div>
      )}

      {selectedService && (
        <div className="modal-bg">
          <div className="modal-box">
            <h2 className="modal-title">{selectedService} Booking</h2>

            {/* ✅ Name and Contact */}
            {[
              {
                label: "Full Name",
                icon: "👤",
                key: "name",
                type: "text",
                placeholder: "Enter your name",
              },
              {
                label: "Contact Number",
                icon: "📞",
                key: "contact",
                type: "tel",
                placeholder: "Enter contact number",
              },
            ].map((f) => (
              <div key={f.key} className="form-group">
                <label>{f.label}</label>
                <div className="input-wrapper">
                  <i className="icon">{f.icon}</i>
                  <input
                    type={f.type}
                    placeholder={f.placeholder}
                    value={form[f.key]}
                    onChange={(e) =>
                      setForm({ ...form, [f.key]: e.target.value })
                    }
                  />
                </div>
              </div>
            ))}

            {/* ✅ Date and Time side by side like Jars & Capsules */}
            <div className="form-row" style={{ display: "flex", gap: "10px" }}>
              {[
                { label: "Select Date", icon: "📅", key: "date", type: "date" },
                { label: "Select Time", icon: "⏰", key: "time", type: "time" },
              ].map((f) => (
                <div
                  key={f.key}
                  className="form-group half"
                  style={{ flex: 1 }}
                >
                  <label>{f.label}</label>
                  <div className="input-wrapper">
                    <i className="icon">{f.icon}</i>
                    <input
                      type={f.type}
                      value={form[f.key]}
                      onChange={(e) =>
                        setForm({ ...form, [f.key]: e.target.value })
                      }
                    />
                  </div>
                </div>
              ))}
            </div>

            {/* ✅ Jars & Capsules remain same */}
            <div className="form-row" style={{ display: "flex", gap: "10px" }}>
              <div className="form-group half">
                <label>Water Jars</label>
                <div className="input-wrapper">
                  <TbBottleFilled color="#03b8b3" className="icon" />
                  <input
                    type="number"
                    placeholder="Qty"
                    value={form.jars}
                    min="0"
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value < 0) return;
                      setForm({ ...form, jars: value });
                    }}
                  />
                </div>
              </div>

              <div className="form-group half">
                <label>Capsules</label>
                <div className="input-wrapper">
                  <GiWaterGallon color="#03b8b3" className="icon" />
                  <input
                    type="number"
                    placeholder="Qty"
                    value={form.capsules}
                    min="0"
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value < 0) return;
                      setForm({ ...form, capsules: e.target.value });
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="form-group">
              <label>Address</label>
              <div className="input-wrapper">
                <LocationOnIcon style={{ color: "red" }} className="icon" />
                <textarea
                  placeholder="Enter full address"
                  value={form.address}
                  onChange={(e) =>
                    setForm({ ...form, address: e.target.value })
                  }
                ></textarea>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                justifyContent: "center",
              }}
            >
              <button
                className="btn"
                disabled={!isFormValid}
                onClick={handleSubmit}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  justifyContent: "center",
                  opacity: !isFormValid ? 0.6 : 1,
                  cursor: !isFormValid ? "not-allowed" : "pointer",
                }}
              >
                Book Now ✅
              </button>
              <button
                className="btn btn-close"
                onClick={() => setSelectedService("")}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  justifyContent: "center",
                }}
              >
                Cancel <CloseIcon />
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Bookservices;
